import { render } from "./LyricsView.vue?vue&type=template&id=df294cf2"
import script from "./LyricsView.vue?vue&type=script&lang=js"
export * from "./LyricsView.vue?vue&type=script&lang=js"

import "./LyricsView.vue?vue&type=style&index=0&id=df294cf2&lang=css"

import exportComponent from "C:\\Programowanie\\Projects\\last38minutes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__